module.exports = __webpack_public_path__ + "static/media/icon-external-link.8299dde9.svg";